"use client";

import { useAuth } from "@/lib/auth-context";
import { apiGetQuiet, apiPost } from "@/lib/api";
import { XCircle } from "@/lib/icons";
import { useEffect, useState } from "react";

interface UserMessage {
  id: number;
  message: string;
  source: string;
  createdAt: string;
}

export default function MessagesBanner() {
  const { user } = useAuth();
  const [messages, setMessages] = useState<UserMessage[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!user) {
      setMessages([]);
      setLoaded(false);
      return;
    }
    apiGetQuiet<UserMessage[]>("/messages")
      .then(setMessages)
      .catch(() => setMessages([]))
      .finally(() => setLoaded(true));
  }, [user]);

  if (!user || !loaded) return null;

  const dismiss = async (id: number) => {
    setMessages((prev) => prev.filter((m) => m.id !== id));
    try {
      await apiPost(`/messages/${id}/dismiss`, {});
    } catch {
      // already removed from UI
    }
  };

  return (
    <div className="bg-amber/10 border-b border-amber/30">
      {messages.length === 0 ? (
        <div className="px-5 py-1.5 text-sm text-muted">No messages</div>
      ) : (
        messages.map((m) => (
          <div
            key={m.id}
            className="flex items-center justify-between px-5 py-1.5 text-sm text-amber"
          >
            <span>{m.message}</span>
            <button
              onClick={() => dismiss(m.id)}
              className="ml-4 text-amber/60 hover:text-amber cursor-pointer shrink-0 leading-none"
              title="Dismiss"
            >
              <XCircle className="w-[18px] h-[18px]" />
            </button>
          </div>
        ))
      )}
    </div>
  );
}
